export const padZerosLeft = (number: number | string, length: number) => {
    let strNumb = '';
    if (number) {
        let intNumb = parseInt(number.toString());
        strNumb = String(intNumb).padStart(length, '0')
    }

    return strNumb;
}